var exports = {
  "w": "xcc377c0b--9eeb47--header",
  "y": "xcc377c0b--9eeb47--links",
};

module.exports = exports;
